module.exports = __webpack_public_path__ + "img/facebook.6fe5851f.svg";